import request from '@/utils/request'


export function getList () {
  return request({
    url: '/api/recharge/index',
    method: 'get'
  })
}

/**
 * 获取上传地址
 * @returns
 */
export function getUploadURL() {
  let url = process.env.VUE_APP_BASE_API+'/api/upload/upload'
  return url
}

/**
 * 充值
 * @param params
 * @returns
 */
export function addOrder(params) {
  return request({
    url: '/api/recharge/addOrder',
    method: 'POST',
    params
  })
}
